import { ConfirmActionDrawer } from '@components/ui/confirm-action-drawer';
import { LIVE_POLL_COPY } from './livePollCopy';

export interface EndLivePollDrawerProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  /** No question was shown yet (H1b, B1b): F4's confirm, with no body line. */
  noQuestionsRun: boolean;
  onConfirm: () => void;
  isConfirming?: boolean;
}

/**
 * The one End confirm (TECH-867 § Decided "One End confirm", L13 = H6), destructive: "End this live poll?" /
 * "Everyone sees the results." / Cancel / "End poll"; before any question ran, "End live poll without asking any
 * questions?". Shared by the big screen (FE-L2b) and the host controls (FE-L1b).
 */
export function EndLivePollDrawer({
  open,
  onOpenChange,
  noQuestionsRun,
  onConfirm,
  isConfirming = false,
}: EndLivePollDrawerProps) {
  return (
    <ConfirmActionDrawer
      open={open}
      onOpenChange={onOpenChange}
      variant="destructive"
      title={
        noQuestionsRun ? LIVE_POLL_COPY.endWithoutQuestionsTitle : LIVE_POLL_COPY.endConfirmTitle
      }
      description={noQuestionsRun ? undefined : LIVE_POLL_COPY.endConfirmBody}
      cancelLabel={LIVE_POLL_COPY.cancel}
      confirmLabel={LIVE_POLL_COPY.endPoll}
      isConfirming={isConfirming}
      onConfirm={onConfirm}
    />
  );
}
